import { render } from "./OrangeButtonOfLawlessness.vue?vue&type=template&id=510ec8e2&scoped=true"
import script from "./OrangeButtonOfLawlessness.vue?vue&type=script&lang=js"
export * from "./OrangeButtonOfLawlessness.vue?vue&type=script&lang=js"

import "./OrangeButtonOfLawlessness.vue?vue&type=style&index=0&id=510ec8e2&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510ec8e2"]])

export default __exports__